import { render } from "./CatalogueView.vue?vue&type=template&id=66cf347e&scoped=true"
import script from "./CatalogueView.vue?vue&type=script&lang=js"
export * from "./CatalogueView.vue?vue&type=script&lang=js"

import "./CatalogueView.vue?vue&type=style&index=0&id=66cf347e&scoped=true&lang=css"

import exportComponent from "C:\\AT\\Sites\\agiles_website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66cf347e"]])

export default __exports__